import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";

export const setCsrUser = createAsyncThunk(
  "setCsrUser",
  async (csrUser, { rejectWithValue, fulfillWithValue }) => {
    return fulfillWithValue(csrUser);
  }
);
export const removeCsrUser = createAsyncThunk(
  "removeCsrUser",
  async (Csruser = {}, { rejectWithValue, fulfillWithValue }) => {
    return fulfillWithValue(Csruser);
  }
);

const CsrUserSlice = createSlice({
  name: "CsrUser",
  initialState: {
    csrUser: {},
  },
  extraReducers: (builder) => {
    builder.addCase(setCsrUser.fulfilled, (state, action) => {
      return (state = {
        ...state,
        csrUser: action.payload,
      });
    });
    builder.addCase(removeCsrUser.fulfilled, (state, action) => {
      return (state = {
        ...state,
        csrUser: action.payload,
      });
    });
  },
});

export default CsrUserSlice.reducer;
